export const offerDefault = {
  customerName: '',
  customerNumber: '',
  cprNumber: '',
  productName: '',
  channel: 'gjensidige',
  objectDescription: '',
  totalPrice: '',
  discountPercentage: 0,
  policyNumber: '',
  agreementNumber: '',
  agreementProductNumber: '',
  pricingAnswers: [],
  disabledPackages: [],
  contractCode: '',
  productCode: '',
  salesChannel: '',
  coupon: {
    couponCode: '',
    couponDiscountPercentage: ''
  },
  purchaseSteps: {
    steps: [
      {
        description: '',
        additionalDescription: ''
      },
      {
        description: '',
        additionalDescription: ''
      },
      {
        description: '',
        additionalDescription: ''
      }
    ],
    value: 0
  },
  errorStatus: {
    errorPageHeader: '',
    errorPageDescription: '',
    shouldDisplayError: false,
    shouldAllowRetry: false,
    statusCode: 0
  }
};

export const productDocumentsDefault = {
  productCode: '',
  contractCode: '',
  segment: '',
  productCategory_SE: '',
  productCategory_EN: '',
  ipidDocumentPath: [],
  prePurchaseInfos: [],
  termsAndConditions: []
};
